import React, { FC } from 'react';
import { Box } from '@bechtel/gds';
import { Text, Icon, IconSize } from '@bechtel/gds';
import { SummaryItemProps } from './index';
import { map } from 'lodash';
export const SummaryItem: FC<SummaryItemProps> = ({ row, iconName, label, value, values }) => {
  return (
    <>
      <Box
        css={{ gridRow: row, gridColumn: 1 }}
        flexGrow={{ sm: 1 }}
        alignItems={{ sm: 'center' }}
        justifyContent={{ sm: 'center' }}
      >
        <Icon icon={iconName} size={IconSize.MEDIUM} fillColor="bechtel.blue.800"></Icon>
      </Box>
      <Box
        css={{ gridRow: row, gridColumn: 2 }}
        flexDirection={{ sm: 'column' }}
        flexGrow={{ sm: 1 }}
        justifyContent={{ sm: 'space-between' }}
      >
        <Text size="400" color="grey.700" weight="600">
          {label}:
        </Text>
        {value.length != 0 ? (
          <Text color="grey.1000" size="400">
            {value}
          </Text>
        ) : (
          values?.length != 0 &&
          value?.length == 0 && (
            <Box flexDirection={{ sm: 'column' }}>
              {map(values, (value: string) => {
                return (
                  <Box my={{ sm: '100' }}>
                    <Text color="grey.1000" size="400">
                      {value}
                    </Text>
                  </Box>
                );
              })}
            </Box>
          )
        )}
      </Box>
    </>
  );
};
